"use client"

import {useEffect, useState} from 'react';
import {Places} from "@/types/Places";
import {placesRequest} from "@/utils/api/Places";
import {SearchFilters} from "@/types/Search";
import {useAppStore} from "@/store/AppStore";
import {useLocale} from "use-intl";
import {useSearchParams} from "next/navigation";

const usePlacesData = (searchFilters?: SearchFilters) => {
  const locale = useLocale()
  const [data, setData] = useState<Places | undefined>(undefined);
  const reload = useAppStore((state) => {
    return state.reloadSearch
  })
  const setReloadSearch = useAppStore((state) => {
    return state.setReloadSearch
  })
  const typeByUrl = useSearchParams().get('type')
  const categoryByUrl = useSearchParams().get('category')


  useEffect(() => {
    const fetchData = async () => {
      const filtersByUrl = {} as SearchFilters
      if (typeByUrl) {
        filtersByUrl['type'] = typeByUrl
        filtersByUrl['page'] = '1'
      }
      if (categoryByUrl) {
        filtersByUrl['category'] = categoryByUrl
        filtersByUrl['page'] = '1'
      }
      const fetched = await placesRequest({...searchFilters, ...filtersByUrl}, locale)
      if (fetched) {
        setData(fetched);
      }
      setReloadSearch(false)
    }
    if (!data || reload) {
      fetchData();
    }
  }, [locale, data, searchFilters, reload, setReloadSearch, typeByUrl, categoryByUrl]);

  return data;
};

export default usePlacesData;
